import { render, staticRenderFns } from "./ModalPanel.vue?vue&type=template&id=67ba2c5e&scoped=true&"
import script from "./ModalPanel.vue?vue&type=script&lang=js&"
export * from "./ModalPanel.vue?vue&type=script&lang=js&"
import style0 from "./ModalPanel.vue?vue&type=style&index=0&id=67ba2c5e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ba2c5e",
  null
  
)

export default component.exports